import { URL } from '../../config'
import { getRequest } from '../functions/httpRequest'

export const membersearch = function (prefix,suffix,token) 
{
  const memberURL =  `${URL.member}/${prefix}/${suffix}` 
  return getRequest(memberURL,'json',token)
}



// WEBPACK FOOTER //
// ./src/utils/api/membersearch.js